import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import classes from "./suggestions.module.css";
import { useSuggestions } from "../../../Pregrine/SearchBar";
import SuggestedProducts from "../suggestedProducts/suggestedProducts";

const Suggestions = (props) => {
  const { displayResult, filters, products, searchValue, setVisible, visible } =
    props;
  const { items } = products;

  const talonProps = useSuggestions({
    displayResult,
    filters,
    items,
    setVisible,
    visible,
  });
  const { onNavigate, shouldRender } = talonProps;

  if (!shouldRender) {
    return null;
  }

  return (
    <Fragment>
      <h2 className={classes.heading}>Product Suggestions</h2>
      <SuggestedProducts onNavigate={onNavigate} products={items} />
      {displayResult && displayResult.length && (
        <Link
          to={`/search?keyword=${searchValue}`}
          style={{
            textAlign: "center",
            textDecoration: "none",
            color: "#111111",
          }}
          onClick={onNavigate}
        >
          <span>View All</span>
        </Link>
      )}
    </Fragment>
  );
};

export default Suggestions;
